import {
  FormSection,
  ControlledInput,
  ControlledDatePicker,
  ControlledTimePicker,
} from "@excent-one/react/form";
import { FormFieldSet } from "@progress/kendo-react-all";
import { withMemoizedContainer } from "@excent-one/react/utils/children";
import { DateTime } from "luxon";
import type { IncidentFormSectionProps, IncidentFormValues } from "../types";

interface IncidentDetailsHeaderSectionProps extends IncidentFormSectionProps {
  /** Only needed for the readOnly time-of-incident display, which reads the live form value
   *  directly rather than via useWatch (matches the pre-extraction behavior). */
  getValues: () => IncidentFormValues;
}

/**
 * The "Incident Form" section: Date Reported/Date of Incident/Venue/Time of Incident. Pure
 * display+edit of fields already inherited straight from IncidentRecordDto (post Part 2 of the
 * refactor) - no page-level data dependency to own.
 */
const IncidentDetailsHeaderSection = withMemoizedContainer(
  FormSection,
  (
    {
      control,
      loading,
      readOnly,
      getValues,
      ...sectionProps
    }: IncidentDetailsHeaderSectionProps,
    Container,
  ) => (
    <Container loading={loading} {...sectionProps}>
      <FormFieldSet cols={2}>
        <ControlledDatePicker
          name="dateReported"
          control={control}
          loading={loading}
          label="Date Reported"
          readOnly={readOnly}
          required={!readOnly}
        />
        <ControlledDatePicker
          name="dateOfIncident"
          control={control}
          loading={loading}
          label="Date of Incident"
          readOnly={readOnly}
          required={!readOnly}
        />
        <ControlledInput
          name="venueOfIncident"
          control={control}
          loading={loading}
          label="Venue of Incident"
          readOnly={readOnly}
          required={!readOnly}
        />
        <ControlledTimePicker
          name="timeOfIncident"
          control={control}
          loading={loading}
          label="Time of Incident"
          format="hh:mm a"
          readOnly={readOnly}
          required={!readOnly}
        />
      </FormFieldSet>
    </Container>
  ),
);

export default IncidentDetailsHeaderSection;
